module.exports = __webpack_public_path__ + "img/20170704_135648_083.bad98c86.jpg";